import React from 'react';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const Box = (props) => {
	const {t, i18n} = useTranslation();
	const { paymentType } = props;
	const icon = t(`profile.saved-payment.${paymentType}.icon`) ? t(`profile.saved-payment.${paymentType}.icon`) : '';
	const title = t(`profile.saved-payment.${paymentType}.title`) ? t(`profile.saved-payment.${paymentType}.title`) : '';
	const textTitle = t(`profile.saved-payment.${paymentType}.text.title`) ? t(`profile.saved-payment.${paymentType}.text.title`) : '';
	const textContent = t(`profile.saved-payment.${paymentType}.text.content`) ? t(`profile.saved-payment.${paymentType}.text.content`) : '';

	return (
		<div className='saved-payment'>
			<div className="saved-payment__box a-center">
				<div className="saved-payment__inner">
					<i className={`saved-payment__icon span span--c-red ${icon}`}></i>
					<h2 className="headline headline--section headline--margin--0">
						{title}
					</h2>
					<div className="saved-payment__tag span span--c-green span--fs-18 span--weight--bold{">
						<i className="fas fa-shield-check"></i>
						{t(`profile.saved-payment.shield`)}
					</div>
					<Link className="saved-payment__btn btn btn--outline btn--outline--lightgray"
						  to={'budget'}>
						<strong>{t(`profile.saved-payment.link`)}</strong>
					</Link>
				</div>
			</div>
			<div className="saved-payment__box">
				<div className="saved-payment__inner">
					<h4 className="headline headline--sub headline--margin--15">
						{textTitle}
					</h4>
					<p className="p">
						{textContent}
					</p>
				</div>
			</div>
		</div>
	);
};

export default Box;
